export enum MessageType
{
    Communication,
    MailEvent
}


export enum CommunicationType
{
    Email,
    SystemEmail,
    SMS
}


export enum MailEventType
{
    Click,
    NotSend,
    Open,
    Replied
}


export interface WebSocketMessageAPIModel
{
    MessageType: string;
}


export interface CommunicationAPIModel extends WebSocketMessageAPIModel
{
    CommunicationType: string;
    Timestamp: string;

    AutobedrijfID?: string;
    SourceService?: number;
    SourceID?: string;

    Email?: EmailAPIModel;
    SMS?: SMSAPIModel;
}


export interface EmailAPIModel
{
    Recipients: EmailAddressAPIModel[];
    Sender: EmailAddressAPIModel;
    Subject: string;
    Html: string;
    Attachments: EmailAttachmentAPIModel[];
}


export interface EmailAddressAPIModel
{
    Name: string;
    Email: string;
}


export interface EmailAttachmentAPIModel
{
    Inline: boolean;
    ContentType: string;
    Naam: string;
    Content: string;
    ContentID?: string;
}


export interface SMSAPIModel
{
    FromName: string;
    To: string;
    Body: string;
}


export interface MailEventAPIModel extends WebSocketMessageAPIModel
{
    MailEventType: string;
    Timestamp: string;

    AutobedrijfID?: string;
    SourceService?: number;
    SourceID?: string;

    Url?: string;
}